/*
* Summary 아이템 리스트 출력
* */

import React, {useEffect, useRef} from "react"
import SummaryList from "./SummaryList";
import {summaryAction} from "../../../redux/store";
import {useDispatch} from "react-redux";

const SummaryListGroup = ({items}) => {
  const dispatch = useDispatch();
  const summaryListRef = useRef([]);

  useEffect(() => {
    const offsetTopList = summaryListRef.current.map(item => item.current?.offsetTop) || 0;
    dispatch(summaryAction.setOffsetTopList(offsetTopList));
  }, [summaryListRef, items]);


  return (
    <>
      {Object.keys(items).map((cameraType, cameraIdx) => {
        summaryListRef.current[cameraIdx] = React.createRef();

        return (
          <div key={cameraIdx} className={"spec-group"} ref={summaryListRef.current[cameraIdx]}>
            <h2>{cameraType === 'EXT' ? 'Exterior' : cameraType === 'INT' ? 'Interior' : cameraType}</h2>
            {Object.keys(items[cameraType]).map((navTitle, navIdx) => {
              const steps = items[cameraType][navTitle];

              const firstStepKey = Object.keys(steps)[0];
              const isColor = steps[firstStepKey]?.type === 'COLOR';

              return (
                <div key={navIdx}>
                  { navTitle !== "PRODUCT" && (
                    <h3>{navTitle}</h3>
                  )}
                  <ul>
                    {Object.keys(steps).map((stepTitle, stepIdx) => (
                      <SummaryList
                        key={stepIdx}
                        title={stepTitle}
                        item={steps[stepTitle].data}
                      />
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}

export default SummaryListGroup;
